var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSurvey
    ? _c(
        "div",
        { staticClass: "visitor-survey" },
        [
          _vm.isRequesting
            ? [_c("spinner")]
            : [
                _vm.event.visitorSurvey &&
                _vm.event.visitorSurvey.questions.length > 0
                  ? [
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "checkout.personalisation.visitorSurvey.subHeadline"
                            )
                          )
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$tm(_vm.event, "descriptionExternal"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.visitorSurveyInstance.questions,
                        function (question) {
                          return [
                            _c("visitor-survey-question-component", {
                              key: _vm.event.eventId + "-" + question.id,
                              attrs: {
                                question: question,
                                initial: _vm.getInitialQuestionData(question),
                                "validate-survey": _vm.validateSurvey,
                              },
                              on: { update: _vm.updateQuestionData },
                            }),
                          ]
                        }
                      ),
                    ]
                  : [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "checkout.personalisation.visitorSurvey.noQuestions"
                            )
                          )
                        ),
                      ]),
                    ],
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }